import {
	INIT_TEAM_CONTEXT,
	INIT_TEAMS_CONTEXT_COMPLETE,
	REFRESH_TEAM_CONTEXT,
	REFRESH_TEAM_CONTEXT_COMPLETE,
	SAVE_TEAM_CONTEXT_COMPLETE,
	UPDATE_TEAM_CONTEXT_PLAYER_COMPLETE
} from "./constants";
import {
	TOGGLE_STARTER_COMPLETE,
	TOGGLE_PARTICIPANT_COMPLETE,
	TOGGLE_ACTIVE_COMPLETE,
	SET_CAPTAIN_COMPLETE
} from "./flag-football-constants";
import {
	TOGGLE_SINGLE_COMPLETE,
	TOGGLE_DOUBLES_COMPLETE
} from "./tennis-constants";

const initialState = {
	teams: {},
	isLoading: false
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case REFRESH_TEAM_CONTEXT:
		case INIT_TEAM_CONTEXT: {
			return {
				...state,
				isLoading: true
			};
		}
		case REFRESH_TEAM_CONTEXT_COMPLETE:
		case INIT_TEAMS_CONTEXT_COMPLETE: {
			const { homeTeamContext, awayTeamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[homeTeamContext.teamId] = homeTeamContext;
			newState.teams[awayTeamContext.teamId] = awayTeamContext;

			return newState;
		}
		case SAVE_TEAM_CONTEXT_COMPLETE: {
			const { teamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[teamContext.teamId] = teamContext;

			return newState;
		}
		case UPDATE_TEAM_CONTEXT_PLAYER_COMPLETE: {
			const { teamContext, player } = payload;
			const newState = { ...state, isLoading: false };
			const currentPlayers = newState.teams[teamContext.teamId].players;
			const newPlayers = currentPlayers.map((currentPlayer) =>
				currentPlayer.id === player.id ? player : currentPlayer
			);

			newState.teams[teamContext.teamId].players = newPlayers;

			return newState;
		}
		case TOGGLE_STARTER_COMPLETE: {
			const { teamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[teamContext.teamId].starters = [...teamContext.starters];

			return newState;
		}
		case TOGGLE_PARTICIPANT_COMPLETE: {
			const { teamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[teamContext.teamId].participants = [
				...teamContext.participants
			];

			return newState;
		}
		case TOGGLE_ACTIVE_COMPLETE: {
			const { teamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[teamContext.teamId].activePlayers = [
				...teamContext.activePlayers
			];

			return newState;
		}
		case SET_CAPTAIN_COMPLETE: {
			const { teamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[teamContext.teamId].captain = teamContext.captain;

			return newState;
		}
		case TOGGLE_SINGLE_COMPLETE: {
			const { teamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[teamContext.teamId].single = [...teamContext.single];

			return newState;
		}
		case TOGGLE_DOUBLES_COMPLETE: {
			const { teamContext } = payload;
			const newState = { ...state, isLoading: false };

			newState.teams[teamContext.teamId].doubles = [...teamContext.doubles];

			return newState;
		}
		default:
			return state;
	}
};

export default reducer;
